import React from 'react';
import { motion } from 'framer-motion';
import { WifiOff, Wifi } from 'lucide-react';
import { useAppStore } from '../../stores/appStore';

export const OfflineIndicator: React.FC = () => {
  const { isOnline, syncStatus, offlineData } = useAppStore();

  if (isOnline && syncStatus === 'idle') return null;

  return (
    <motion.div
      initial={{ opacity: 0, y: -50 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: -50 }}
      className={`
        fixed top-16 left-4 right-4 z-50 p-3 rounded-lg shadow-lg
        ${!isOnline 
          ? 'bg-yellow-50 border border-yellow-200' 
          : 'bg-blue-50 border border-blue-200'
        }
      `}
    >
      <div className="flex items-center space-x-3">
        <div className={`
          w-8 h-8 rounded-full flex items-center justify-center
          ${!isOnline ? 'bg-yellow-100' : 'bg-blue-100'}
        `}>
          {!isOnline ? (
            <WifiOff className="w-4 h-4 text-yellow-600" />
          ) : (
            <Wifi className="w-4 h-4 text-blue-600" />
          )}
        </div>
        
        <div className="flex-1">
          <p className={`
            font-medium text-sm
            ${!isOnline ? 'text-yellow-800' : 'text-blue-800'}
          `}>
            {!isOnline ? 'Working Offline' : 'Syncing Data'}
          </p>
          <p className={`
            text-xs
            ${!isOnline ? 'text-yellow-600' : 'text-blue-600'}
          `}>
            {!isOnline 
              ? `${offlineData.length} items pending sync`
              : 'Updating warehouse data...'
            }
          </p>
        </div>
        
        {syncStatus === 'syncing' && (
          <div className="w-4 h-4 border-2 border-blue-600 border-t-transparent rounded-full animate-spin" />
        )}
      </div>
    </motion.div>
  );
};